import { mergeStyleSets } from '@uifabric/merge-styles';
import theme from '../../theme.style';
import { pxToRem } from '../../utils';

export default mergeStyleSets({
  iconColumnHeader: {
    selectors: {
      '& .ms-DetailsHeader-cellName': {
        height: pxToRem(20),
        width: pxToRem(20),
        textAlign: 'center',
        fontSize: '1rem',
        position: 'absolute',
        top: '50%',
        transform: 'translateY(-50%)',
      },
    },
  },
  headerIcon: {
    maxHeight: pxToRem(16),
    maxWidth: pxToRem(16),
    fontSize: '1rem',
    verticalAlign: 'middle',
  },
  iconColumnHeaderSelectButton: {
    cursor: 'pointer',
    selectors: {
      '& .ms-DetailsHeader-cellName': {
        top: pxToRem(14),
        left: pxToRem(7),
        position: 'absolute',
      },
      '&:hover': {
        background: 'transparent',
      },
      '&:focus': {
        background: 'transparent',
      },
      '&:active': {
        background: 'transparent',
      },
      '& .ms-DetailsHeader-cellName .ms-Icon': {
        fontSize: pxToRem(16),
        color: theme.palette.themePrimary,
      },
    },
  },
  selectButton: {
    height: pxToRem(34),
  },
  buttonContainer: {
    justifyContent: 'flex-end',
    display: 'flex',
    alignItems: 'center',
    paddingTop: pxToRem(20),
    selectors: {
      '& .ms-Button': {
        padding: pxToRem(6),
        fontSize: pxToRem(13),
      },
    },
  },
  actionButton: {
    marginRight: pxToRem(16),
  },
  loadingSpinner: {
    marginLeft: pxToRem(10),
  },
  infoIcon: {
    position: 'relative',
    fontSize: pxToRem(14),
    color: theme.palette.themePrimary,
  },
  alignCenter: {
    justifyContent: 'center',
  },
});
